import { Component, OnInit } from '@angular/core';
import { MaterialImports } from '../../material.imports';
import { LanguageService, SupportedLanguage } from '../../services/language.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-choose-language',
  standalone: true,
  imports: [...MaterialImports, CommonModule, FormsModule, TranslateModule],
  templateUrl: './choose-language.html',
  styleUrl: './choose-language.scss',
})
export class ChooseLanguage implements OnInit {
  currentLanguage: SupportedLanguage = 'en';
  supportedLanguages: SupportedLanguage[] = [];

  constructor(public languageService: LanguageService) {}

  ngOnInit(): void {
    this.currentLanguage = this.languageService.getCurrentLanguage();
    this.supportedLanguages = this.languageService.getSupportedLanguages();
  }

  onLanguageChange(language: SupportedLanguage): void {
    this.languageService.setLanguage(language);
    this.currentLanguage = language;
  }

  getLanguageDisplayName(language: SupportedLanguage): string {
    return this.languageService.getLanguageDisplayName(language);
  }
}
